{
  "validations": {
    "required": "%{name} es obligatorio",
    "start_end": "La fecha de finalización no puede ser anterior a la de inicio",
    "short": "%{} es demasiado corto",
    "long": "%{} es demasiado largo"
  }
}
